// Runtime env takes priority over build-time env.
// window._env_ is populated by docker-entrypoint.sh at container startup;
// it writes unset variables as "", so an empty value means "not set".
export function runtimeEnv(name) {
  const runtime = String((window._env_ && window._env_[name]) || "").trim();
  return runtime || String(process.env[name] || "").trim();
}

const API_BASE_URL = runtimeEnv("REACT_APP_API_URL") || "http://localhost:9000";

// The API version this frontend targets — bump this one value on a future
// version migration instead of re-sweeping every call site again.
export const API_PREFIX = "/api/v1";

// Deployment default for the colour theme: "system" | "light" | "dark".
// A user's own toggle choice (localStorage) always wins; see theme.js.
export const DEFAULT_THEME = runtimeEnv("REACT_APP_DEFAULT_THEME") || "system";

// Shell branding (sidebar brand block; the document title stays in index.html).
export const BRAND_NAME = runtimeEnv("REACT_APP_BRAND_NAME") || "Graph RAG";
export const BRAND_TAGLINE = runtimeEnv("REACT_APP_BRAND_TAGLINE") || "Knowledge Base Q&A";

export default API_BASE_URL;
